export enum TripVersionReason {
  Created = 0,
  Updated = 1,
  Completed = 2,
  Deleted = 3,
  PlannedActivitiesAdded = 4,
  PlannedActivitiesUpdated = 5,
  PlannedActivitiesDeleted = 6,
  PaxOverviewsAdded = 7,
  PaxOverviewsUpdated = 8,
  PaxOverviewsDeleted = 9,
}

export const TripVersionReasonLabels = {
  [TripVersionReason.Created]: 'created',
  [TripVersionReason.Updated]: 'updated',
  [TripVersionReason.Completed]: 'completed',
  [TripVersionReason.Deleted]: 'deleted',
  [TripVersionReason.PlannedActivitiesAdded]: 'crewMembersAdded',
  [TripVersionReason.PlannedActivitiesUpdated]: 'crewMembersUpdated',
  [TripVersionReason.PlannedActivitiesDeleted]: 'crewMembersDeleted',
  [TripVersionReason.PaxOverviewsAdded]: 'passengersAdded',
  [TripVersionReason.PaxOverviewsUpdated]: 'passengersUpdated',
  [TripVersionReason.PaxOverviewsDeleted]: 'passengersDeleted',
};
